// extracted by mini-css-extract-plugin
export default {"question":"Likert_question__y87X4"};